module.exports = __webpack_public_path__ + "static/media/btn_slide_close.ee5f5ddd.svg";